/**
 * FULL BG SLIDER
 * author: @matej.kamenec
 */

function HomeSlider() {
    this.sliderElement = $('.header__slider');
    var si = $('.sliderimages').data('src');
    var sim = $('.sliderimages').data('src-mob');
    if(si && sim) {
        this.banners = si.split(';');
        this.banners_mob = sim.split(';');
        this.bannersLength = this.banners.length;
        var randomNumber = getRandomInt(0, this.bannersLength);

        this.setSlides();
        this.showSlide(0);

        if(this.bannersLength > 1) {
            this.tick();
        }
    }
}

HomeSlider.prototype.setSlides = function() {
    this.sliderElement.append('<ul></ul>');
    var list = this.sliderElement.find('ul');
    for(var i = 0; i < this.banners.length; i++) {
        list.append('<li><picture><source srcset="' + this.banners_mob[i] + '" media="(max-width: 480px)" /><img id="slide_' + i + '" src="' + this.banners[i] + '"></picture></li>');
    }
}

HomeSlider.prototype.hideSlides = function(slides) {
    slides.fadeOut(700);
};

HomeSlider.prototype.showSlide = function(index) {
    var slides = this.sliderElement.find('ul li');
    this.hideSlides(slides);
    slides.eq(index).fadeIn(700);
    this.lastSlide = index;
}

HomeSlider.prototype.tick = function() {
    var _this = this;
    var newIndex = (this.lastSlide === this.bannersLength - 1) ? 0 : this.lastSlide + 1;
    setTimeout(function(){
        _this.showSlide(newIndex);
        _this.tick();
    }, 7000);
};

HomeSlider.prototype.setHomeSize = function() {
    var height = ($(window).outerWidth() >= 700) ? $(window).height() - 1 : 480;
    $('.header__slider, header').css('height', height);
};

HomeSlider.prototype.setOthersSize = function() {
    var height = ($(window).outerWidth() > 750 && !$('header').hasClass('noBookingBox')) ? 400 : 250;
    $('.header__slider, header').css('height', height - 1 + 'px');
    $('.page').css('margin-top', height + 'px');
};
